var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInserted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.15-200v-39h59.23q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-431.76q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92h-59.23v-40h59.23q27.62 0 46.12 18.5Q470-723 470-695.38v430.76q0 27.62-18.5 46.12Q433-200 405.38-200h-59.23ZM630-200q-27.62 0-46.12-18.5-18.5-18.5-18.5-46.12v-430.76q0-27.62 18.5-46.12Q602.38-760 630-760h185.38q27.62 0 46.12 18.5Q880-723 880-695.38v430.76q0 27.62-18.5 46.12Q843-200 815.38-200H630Zm0-39h185.38q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-431.76q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H630q-10.77 0-17.69 6.92-6.93 6.93-6.93 17.7v431.76q0 10.77 6.93 17.7Q619.23-239 630-239ZM228.46-355.38l-28.54-28.31L278.31-460H80v-40h198.31l-78.39-75.31 27.77-28.54L355.38-480 228.46-355.38ZM605.38-239v-481 481Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInserted);
export default __webpack_public_path__ + "static/media/inserted.20cfb027938966c69852ca364876781c.svg";
export { ForwardRef as ReactComponent };